import React from 'react';

const ArStep3_2 = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="260"
      height="172"
      viewBox="0 0 260 172"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.708 30.8165C32.6696 26.4646 36.5273 23.3662 40.9842 23.3662H219.359C223.824 23.3662 227.686 26.4758 228.64 30.838L256.86 159.971C258.154 165.895 253.643 171.499 247.579 171.499H12.4508C6.3779 171.499 1.8643 165.879 3.17458 159.949L31.708 30.8165Z"
        stroke="#ADB5BD"
      />
      <path d="M42.5 23.5L12.9502 171.005" stroke="#ADB5BD" />
      <path d="M51.7909 23.082L25.7548 170.955" stroke="#ADB5BD" />
      <path d="M61.7279 23.4299L38.903 171.832" stroke="#ADB5BD" />
      <path d="M72.6489 22.798L52.9779 171.65" stroke="#ADB5BD" />
      <path d="M81.6858 22.8662L64.751 171.005" stroke="#ADB5BD" />
      <path d="M91.6475 22.8662L78.6973 171.005" stroke="#ADB5BD" />
      <path d="M101.609 22.8662L91.6475 171.005" stroke="#ADB5BD" />
      <path d="M111.571 22.8662L104.598 171.005" stroke="#ADB5BD" />
      <path d="M120.536 22.8662L117.548 171.005" stroke="#ADB5BD" />
      <path d="M131.494 22.8662L130.498 171.005" stroke="#ADB5BD" />
      <path d="M140.5 23.5L143.449 171.005" stroke="#ADB5BD" />
      <path d="M150.422 22.8662L157.395 171.005" stroke="#ADB5BD" />
      <path d="M159.5 23.5L169.348 171.005" stroke="#ADB5BD" />
      <path d="M182.299 171.005L169.5 23.5" stroke="#ADB5BD" />
      <path d="M195.249 171.005L179 23.5" stroke="#ADB5BD" />
      <path d="M210.192 171.005L189.5 23.5" stroke="#ADB5BD" />
      <path d="M222.145 171.005L198.5 23.5" stroke="#ADB5BD" />
      <path d="M235.096 171.005L208.5 23.5" stroke="#ADB5BD" />
      <path d="M248.046 171.005L218.5 23.5" stroke="#ADB5BD" />
      <path
        d="M33 29.8262H227.127"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M30.8818 37.7793H229"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M29.5 45.7344L231 45.7344"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M27.5 54.6816L233.104 54.6816"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M25.5 62.6348L234.5 62.6348"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M23.5 71.583H236"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M22 80.5312L238 80.5313"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M19.5 90.4736L240.5 90.4736"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M16.9355 101.41H243.066"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M15 111.352H245.058"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M10.5 133.225H250.039"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M6.97363 146.149H253.027"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M4.5 158H255.5"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M12.5 122.289H247.5"
        stroke="#ADB5BD"
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <path
        d="M161.5 6L174.5 7.5L189 11.5L204 15.5L211 18.5L216.5 25.5L202 88L192.5 124L187.5 142.5L180 149.5L168.5 149L154 145.5L136 140.5L127 133.5V124L129.5 115L156 15.5L161.5 6Z"
        fill="url(#paint0_linear_687_6884)"
      />
      <path
        d="M155.094 16.1636C157.097 8.62754 164.871 4.18042 172.382 6.27377L206.483 15.7773C213.833 17.8256 218.189 25.3815 216.279 32.7682L188.562 139.956C186.614 147.491 178.894 151.991 171.377 149.972L136.468 140.596C129.014 138.594 124.587 130.937 126.569 123.478L155.094 16.1636Z"
        stroke="black"
        strokeOpacity="0.85"
        strokeWidth="4"
      />
      <rect
        width="1.9921"
        height="14.915"
        rx="0.99605"
        transform="matrix(0.96919 0.246314 -0.244597 0.969625 214.181 45.7285)"
        fill="black"
      />
      <rect
        width="1.9921"
        height="14.915"
        rx="0.99605"
        transform="matrix(0.96919 0.246314 -0.244597 0.969625 145.438 39.7695)"
        fill="black"
      />
      <rect
        width="1.9921"
        height="14.915"
        rx="0.99605"
        transform="matrix(0.96919 0.246314 -0.244597 0.969625 149.422 23.8613)"
        fill="black"
      />
      <ellipse
        cx="161.483"
        cy="45.474"
        rx="4.48276"
        ry="4.47399"
        fill="#EF476F"
      />
      <ellipse
        cx="176.483"
        cy="101.474"
        rx="4.48276"
        ry="4.47399"
        fill="#EF476F"
      />
      <ellipse
        cx="155.483"
        cy="132.474"
        rx="4.48276"
        ry="4.47399"
        fill="#EF476F"
      />
      <defs>
        <linearGradient
          id="paint0_linear_687_6884"
          x1="215.844"
          y1="20.2132"
          x2="128.233"
          y2="134.931"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E4E4" stopOpacity="0.8" />
          <stop offset="1" stopColor="#F1F1F1" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ArStep3_2;
